import { Layout } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { melioIcon } from '@tools/ui/assets';
import { Module, ModuleRouter } from '@tools/ui/types';
import IconWrap from '../../common/icons/antIconWrap';
import SideMenu from './SideMenu';
import UserProfile from './UserProfile/UserProfile.component';

const { Sider } = Layout;

const SiderStyle = styled(Sider)`
  box-shadow: rgb(85 85 85 / 50%) 0 2px 6px 0;
  height: 100vh;
  position: fixed;
  z-index: 2;
`;

const SiderChildrenContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: space-between;
`;

const ProfileContainer = styled.div`
  text-align: center;
  height: 90px;
`;

type IProps = {
  menuItemsRoute: (Module | ModuleRouter)[];
  selectedKeyRoute: number;
};

const SideContainer: React.FC<React.PropsWithChildren<IProps>> = ({
  selectedKeyRoute,
  menuItemsRoute,
}) => {
  return (
    <SiderStyle trigger={null} collapsed={true}>
      <SiderChildrenContainer>
        <SideMenu menuItemsRoute={menuItemsRoute} selectedKeyRoute={selectedKeyRoute} />
        <ProfileContainer>
          <UserProfile />
          <IconWrap component={melioIcon} style={{ fontSize: 50 }} />
        </ProfileContainer>
      </SiderChildrenContainer>
    </SiderStyle>
  );
};

export default SideContainer;
